<template>
    <div data-testId="logo-header">
        <a
            v-if="showAlternateLogo"
            :href="getPortalLink()"
            target="_blank"
            class="logo-container alternate-logo-container gtm-public-logo-noel"
        >
            <img
                data-testid="mobile-header-logo"
                :src="getAlternateLogoUrl"
                :class="getLogoClasses"
                alt="logo-clicsante-header"
            />
        </a>
        <a v-else :href="getPortalLink()" class="logo-container">
            <img
                data-testid="mobile-header-logo"
                :src="getLogoUrl"
                :class="getLogoClasses"
                alt="logo-clicsante-header"
            />
        </a>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { inferPortalUrl } from '@/helpers/env';

export default {
    name: 'logo-header',
    computed: {
        ...mapGetters({
            getLogoUrl: 'getLogoUrl',
            getAlternateLogoUrl: 'getAlternateLogoUrl',
            getLocale: 'locale',
            getStaticFilesUrl: 'getStaticFilesUrl',
        }),
        showAlternateLogo() {
            const now = new Date();
            const expirationDate = new Date('2024-01-08 00:00:00');
            return now < expirationDate;
        },
        getLogoClasses() {
            return this.$vuetify.breakpoint.smAndDown ? 'mobile-header-logo' : 'logo';
        },
    },
    methods: {
        getPortalLink() {
            return inferPortalUrl();
        },
    },
};
</script>

<style lang="scss" scoped>
.alternate-logo-container .logo {
    top: -15px;
}

.logo {
    top: 8px;
    position: absolute;
    width: 100%;
    min-width: 175px;
    max-width: 155px;
    filter: drop-shadow(0px 3px 6px #00000029);
    @media only screen and (max-width: 1246px) {
        max-width: 80px;
        min-width: 80px;
        top: calc(50% - 40px);
    }
}

.mobile-header-logo {
  width: 75px;
}
</style>
